import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import * as React from "react";
import {FreeToPlayAnimatedIconBox} from "./boxes/free-to-play-animated-icon.box";
import { AnimatedIconObservableTarget, AnimatedIconUnloadReason, IAnimatedIconRequestOptions } from "../../services/pixi-app/animated-icon-base-service.service";
import { CHANNEL_ELEMENTS, CHANNEL_SOURCE } from "../../../common/const/casinofied-analytics-consts";
import { AreaType } from "@sparkware/uc-sdk-core";
import { observer } from "mobx-react";
import {CyClass} from "../../../common/cy-classes";
import {ISendElasticEventOptions} from "../../services/analytics/analytics.service.interface";

export const FreeToPlayAnimatedIconComponent = observer(class FreeToPlayAnimatedIconComponent extends OrbitComponent {
    private iconRequestOptions = {
        jsonUrl: this.services.theme.currentTheme.images.f2p.freeToPlay.toString(),
        size: {
            width: 445,
            height: 364
        },
        timings: {
            delay: 2000,
            interval: 3000
        }
    };

    private iconObservableTarget: AnimatedIconObservableTarget | undefined;

    private _captureElementRefForIcon(element: HTMLElement | null) {
        // if element is null (the component was unmounted) or the element changed, then check if we have a currently running/loading animation and remove it
        if (!element || (this.iconObservableTarget && this.iconObservableTarget.wrapper !== element)) {
            // if the current animation is loading, cancel it
            if (this.iconObservableTarget && this.iconObservableTarget.loadingInProgress) {
                this.iconObservableTarget.abortLoading = true;
            }
            // if the current animation is already running, stop and dispose it
            if (this.iconObservableTarget && this.iconObservableTarget.animationDisposer) {
                this.iconObservableTarget.animationDisposer(AnimatedIconUnloadReason.REQUESTED);
            }
        }
        // if the element exists and is different from the previous one, then the animation must be started
        if (element && (!this.iconObservableTarget || this.iconObservableTarget.wrapper !== element)) {
            let requestOptions: Omit<IAnimatedIconRequestOptions, "wrapper"> = this.iconRequestOptions;
            // update the reference
            this.iconObservableTarget = {
                ...requestOptions,
                wrapper: element
            };
            this.services.freeToPlay.loadFreeToPlayAnimation(this.iconObservableTarget);
        }
        // if element is null just update the reference so we know next time the capture is ran
        if (!element) {
            this.iconObservableTarget = undefined;
        }
    }

    componentDidUpdate() {
        if (this.services.freeToPlay.isPromotionEligible) {
            this._sendAnalytics("SHOW");
        }
    }

    render() {
        if (!this.services.freeToPlay.isPromotionEligible) {
            return null;
        }

        if (this.services.freeToPlay.isPromotionOpened) {
            return null;
        }

        return (
            <FreeToPlayAnimatedIconBox
                className={CyClass('cy-free-to-play-icon')}
                isHybridEmbedded={this.services.device.hybrid.isEmbedded} 
                onPointerUp={()=> this._openBonusWheel()}
                ref={this._captureElementRefForIcon.bind(this)}
            />
        );
    }

    private _openBonusWheel = async () => {
        this._sendAnalytics("CLICK");
        await this.services.freeToPlay.showPromotion({
            channel: {
                area: AreaType.button,
                source: CHANNEL_SOURCE.casinoClient,
                element: CHANNEL_ELEMENTS.floatingIcon
            }}
        );
    }

    private _sendAnalytics(action: string) {
        try {
            let options: ISendElasticEventOptions = {
                action: action,
                category: "Floating_icon",
                eventType: "bonus_widget",
                appID: "F2P",
                customData: {
                    location: this.services.location.isHomePage ? 'homepage' : this.services.location.currentUri.pathName.toString(),
                    segmentation: this.services.user.playerRMSStatus
                }
            };
            this.services.analytics.sendElasticInfoEvent(options, true);
        }
        catch (err){
            console.log("Floating_icon " + action + " analytics report failed with error: "+ err);
        }
    }
});